var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Button,{attrs:{"tag":"button","size":"regular","type":"tertiary","icon-only":""},on:{"click":function($event){return _vm.$emit('click')}},scopedSlots:_vm._u([{key:"slotBefore",fn:function(){return [_c(_setup.Icon,{attrs:{"name":"print","group":"general"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }